module.exports = {
  'primary-color': '#C60800',
  'layout-header-height': '48px',
  'layout-header-background': '#F0F2F5',
};
